@for (layer of panelLayers(); track layer.dependsOnStringified; let last = $last) {
    <div
        #panelContent
        [@appear]
        [@.disabled]="layer.animationDisabled"
        [style.z-index]="($index + 1) * 10"
        [class.content__bottom-panel]="!last"
        class="content__panel"
    >
        <div class="content__panel-component">
            <ng-container *ngComponentOutlet="layer.component; inputs: layer.inputBindings"/>
        </div>
        @if (layer.keyboardShortcuts) {
            <div class="shortcuts" [innerHTML]="layer.keyboardShortcuts"></div>
        }
        <img class="close-button" src="assets/images/common/cancel.svg" (click)="closePanel($event, layer)" alt="close"/>
    </div>
}
